import { Apple, GooglePlay } from "@/components/Icon"
import Flex from "@/components/Flex"
import styled from "@emotion/styled"
import React from "react"
import Typography from "@/components/Typography"
import Link from "@/components/Link"
import { useUserAgent } from "@/components/hooks/useUserAgent"
import { BoxProps } from "@/components/Box"
import { useSmartScript } from "@/utils/onelink/SmartScriptProvider"
import { useOneLink } from "@/components/hooks/useOneLink"

const DownloadButton = styled(Flex)`
  justify-content: center;
  align-items: center;
  gap: 8px;
  height: 44px;
  border-radius: 40px;
  cursor: pointer;
`

export const DownloadCTA = ({
  text,
  curLang = "en",
  color = "#0B1426",
  bg = "#F7F9FA",
  p = "10px 48px",
  iconDirection = "left",
  width = "auto",
  campaign = "pay",
  ...restProps
}: {
  text: string
  curLang: string
  color?: string
  bg?: string
  p?: string | string[]
  iconDirection?: "left" | "right"
  width?: number | number[] | string | string[]
  campaign?: string
} & BoxProps) => {
  const userAgent = useUserAgent()
  const isIos = userAgent === "ios"
  const isAndroid = userAgent === "android"
  const neitherIosNorAndroid = !isIos && !isAndroid
  const { queryString } = useOneLink()

  const { oneLinkUrl } = useSmartScript()
  const href =
    oneLinkUrl ||
    `https://crypto.onelink.me/J9Lg/smartscriptfallback${queryString}`
  return (
    <>
      {(isAndroid || neitherIosNorAndroid) && (
        <Link href={href}>
          <DownloadButton bg={bg} color={color} p={p} {...restProps}>
            {isIos ? (
              <Apple
                fontSize={"16px"}
                color={color}
                order={iconDirection === "left" ? 0 : 1}
              />
            ) : (
              <GooglePlay
                fontSize={"16px"}
                color={color}
                order={iconDirection === "left" ? 0 : 1}
              />
            )}
            <Typography
              variant="p"
              fontWeight={600}
              fontSize={curLang === "fr" || curLang === "fr-CA" ? 14 : 16}
              lineHeight={"150%"}
              textAlign={"center"}
            >
              {text}
            </Typography>
          </DownloadButton>
        </Link>
      )}
    </>
  )
}
